import axios from 'axios'
import { getIdToken } from 'firebase/functions'

export default class CmsApis {

  /*eslint-disable */
  // storeToken and baseURL will be set when successfully fetch preferences
  storeToken = ''
  baseURL = ''

  static requestWithCredential(config){
    return getIdToken()
      .then((idToken) => (
        CmsApis.request({
          ...config,
          headers: {
            ...config.headers,
            'x-auth-token': idToken
          },
        })
      ))
  }

  static request(config){
    return axios({
      ...config,
      baseURL: CmsApis.baseURL,
      headers: {
        'x-store-token': CmsApis.storeToken,
        ...config.headers,
      },
    })
    .then(({ data }) => {
      return data
    })
    .catch((error) => {
      if (error.response) {
        throw { error: error.response.data.error, status: error.status } // eslint-disable-line no-throw-literal
      } else {
        throw error
      }
    })
  }

  static getStorePreferences() {
    let hostname = window.location.hostname
    if (hostname === 'localhost') {
      // change hostname to host
      // ex. localhost:3001
      // to separate between store from PORT
      hostname = window.location.host
    }
    return CmsApis.request({
      method: 'GET',
      url: `/cms/store-config?hostname=${hostname}`,
    })
  }

  static getStoreTemplates() {
    return CmsApis.request({
      method: 'GET',
      url: `/cms/store-templates`,
    })
  }

  static getStoreTheme(storeId) {
    return CmsApis.request({
      method: 'GET',
      url: '/cms/theme',
      headers: {
        'x-store-token': storeId,
      }
    })
  }

  static getElements() {
    return CmsApis.request({
      method: 'GET',
      url: `/cms/elements`,
    })
  }

  static getGlobalBanner() {
    return CmsApis.request({
      method: 'GET',
      url: `/cms/categoryBanner/global`,
    })
  }

  static updateGlobalBanner(data) {
    return CmsApis.request({
      method: 'PUT',
      url: `/cms/categoryBanner/global`,
      data: {
        data,
        name: data.name,
      }
    })
  }
  
  static getCategoryBanners() {
    return CmsApis.request({
      method: 'GET',
      url: `cms/categoryBanner/categories`,
    })
  }

  static getCategoryBannerById(id) {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: `/cms/categoryBanner/categories/${encodeURIComponent(id)}`
    })
  }

  static updateCategoryBannerById(data) {
    return CmsApis.request({
      method: 'PUT',
      url: `/cms/categoryBanner/categories/${data.id}`,
      data
    })
  }

  static createCategoryBanner(data) {
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/categoryBanner/categories`,
      data
    })
  }

  static deleteCategoryBannerById(id) {
    return CmsApis.requestWithCredential({
      method: 'DELETE',
      url: `/cms/categoryBanner/categories/${id}`
    })
  }

  static getTagBanners() {
    return CmsApis.request({
      method: 'GET',
      url: `cms/categoryBanner/tags`
    })
  }

  static getTagBannerById(id) {
    return CmsApis.request({
      method: 'GET',
      url: `/cms/categoryBanner/tags/${id}`
    })
  }

  static createTagBanner(data) {
    return CmsApis.request({
      method: 'POST',
      url: '/cms/categoryBanner/tags',
      data,
    })
  } 

  static updateTagBannerById(data) {
    return CmsApis.request({
      method: 'PUT',
      url: `/cms/categoryBanner/tags/${data.id}`,
      data,
    })
  }

  static deleteTagBannerById(id) {
    return CmsApis.requestWithCredential({
      method: 'DELETE',
      url: `/cms/categoryBanner/tags/${id}`
    })
  }

  static getMenus() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: '/cms/menus',
    })
  }

  static getStaticMenus() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: '/cms/static-menus',
    })
  }

  static getMenuById(id) {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: `/cms/menus/${encodeURIComponent(id)}`
    })
  }

  static updateMenuById(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/menus/${encodeURIComponent(data.id)}`,
      data
    })
  }

  static updateStaticMenus(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/static-menus`,
      data
    })
  }

  static createMenu(data) {
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/menus`,
      data,
    })
  }

  static duplicateMenu(data) {
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/duplicate/menu`,
      data,
    })
  }

  static deleteMenuById(id) {
    return CmsApis.requestWithCredential({
      method: 'DELETE',
      url: `/cms/menus/${encodeURIComponent(id)}`,
    })
  }

  static getPages() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: '/cms/pages',
    })
  }

  static getPageById(id) {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: `/cms/pages/${encodeURIComponent(id)}`
    })
  }

  static updatePageById(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/pages/${encodeURIComponent(data.id)}`,
      data
    })
  }

  static createPage(data) {
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/pages`,
      data,
    })
  }
  
  static duplicatePage(data) {
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/duplicate/pages`,
      data
    })
  }

  static deletePageById(id) {
    return CmsApis.requestWithCredential({
      method: 'DELETE',
      url: `/cms/pages/${encodeURIComponent(id)}`,
    })
  }

  static getStaticPages() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: '/cms/static-pages',
    })
  }

  static updateStaticPages(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/static-pages`,
      data
    })
  }

  static getLinkPages() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: `/cms/link-pages`
    })
  }

  static updateLinkPages(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/link-pages`,
      data: {
        name: 'staticLinks',
        data: data,
      }
    })
  }

  static getStoreLocator() {
    return CmsApis.requestWithCredential({
      method: 'GET',
      url: `/cms/storeLocator`,
    })
  }

  static updateStoreLocator(data) {
    return CmsApis.requestWithCredential({
      method: 'PUT',
      url: `/cms/storeLocator`,
      data: {
        data: data,
        name: 'store',
      }
    })
  }

  static getLinkMedia(file) {
    const data = { name: file.name, type: file.type}
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    return CmsApis.requestWithCredential({
      method: 'POST',
      url: `/cms/upload-media`,
      data,
    })
      .then((result) => {
        const { data: { uploadUrl, downloadUrl }} = result
        const blob = new Blob([reader.result]);
        return axios({
            method: 'PUT',
            url: uploadUrl,
            data: blob ,
            headers: {
              'Content-Type': file.type,
            },
          })
          .then(() => downloadUrl)
      })
  }
}



// WEBPACK FOOTER //
// ./src/apis/cmsApis.js